export const removeFav = (removeFav) => ({
    type: 'SET_FOR_REMOVE',
    payload: removeFav,
  });